 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		235: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + {"0":"5dea399","1":"4b3cdec","2":"9a0966b","3":"40e82b1","4":"a77f42e","5":"142902e","6":"325b48e","7":"3c58b10","8":"67297fa","9":"79ec6a4","10":"7f1e18a","11":"ae68167","12":"0938057","13":"1b06178","14":"9cfb371","15":"9548d7c","16":"45dbd6c","17":"0e2e32b","18":"2f8da44","19":"8cee0b7","20":"89b281b","21":"24c8812","22":"fcf22bc","23":"164bd04","24":"770381b","25":"f553267","26":"dd47cbc","27":"ab4051f","28":"f77b304","29":"a68fb8a","30":"6993ea2","31":"d65419b","32":"cfa3739","33":"6cbb1b7","34":"b38dc32","35":"49a57a3","36":"3edcb79","37":"e15db8b","38":"7e977b9","39":"f18791c","40":"51b35b4","41":"32da45c","42":"aa78eed","43":"19e62fb","44":"0ecb9c4","45":"22d2ea3","46":"c5a8f43","47":"de327ac","48":"95ed1a1","49":"9288ef6","50":"92d7b0e","51":"811c625","52":"da353f6","53":"18be620","54":"5e2b8e9","55":"eb15978","56":"7d0fe3c","57":"dcb575c","58":"b0b65af","59":"5193cac","60":"fbd9bbd","61":"35bb756","62":"7957ff7","63":"a32eeff","64":"b6f3fd5","65":"ec9628e","66":"d2ff071","67":"6ad6308","68":"ab39aac","69":"af69fe5","70":"bf37e9c","71":"c8cdc92","72":"7aa381f","73":"ec06fbb","74":"94385b2","75":"8e7086f","76":"a958c2e","77":"1127169","78":"b270b05","79":"4ac182c","80":"4719126","81":"a7141b0","82":"2098866","83":"ef143d3","84":"b611b87","85":"56e096a","86":"18ad692","87":"77e6e68","88":"20a8688","89":"a11d3a0","90":"678c847","91":"80d9a47","92":"6816404","93":"cec8e40","94":"9c815b4","95":"bac4d2e","96":"2d41257","97":"6d0b33d","98":"22e761b","99":"e9bd93c","100":"a68c2e9","101":"e93b721","102":"55d3465","103":"d15712f","104":"c5c2733","105":"6c25e73","106":"a9562dc","107":"99dec75","108":"1982768","109":"fb2b579","110":"72c521f","111":"9a09677","112":"00e98a5","113":"6c4c46c","114":"b73d8c9","115":"5d6c504","118":"2411dbe","119":"a4c3202","120":"512c97e","121":"4b97ac4","122":"600aba9","123":"b4ae74d","124":"dd540a7","125":"2d82354","126":"b45922b","127":"f40f675","128":"bb26451","129":"94e13ea","130":"e683d43","131":"a4ecf47","132":"a433a08","133":"63dfd5d","134":"ea686d1","135":"7213508","136":"d2eae5d","137":"ec2b05b","138":"90e1af3","139":"c945027","140":"64ee371","141":"98c6225","142":"7a6f84a","143":"af607c0","144":"5fc18b4","145":"9ec65a2","146":"eeaed82","147":"de5f527","148":"0678db2","149":"8a69fb9","150":"d4f05d6","151":"a88bdb4","152":"38f7fcc","153":"0a9d747","154":"36c89a0","155":"10000b3","156":"dd242ea","157":"a33e078","158":"b3e0e1c","159":"15511d6","160":"ac7c8d5","161":"f2f53eb","162":"26c607d","163":"9dacda5","164":"eea7d60","165":"e73b39d","166":"da0285b","167":"98af671","168":"9ce7691","169":"e6f8717","170":"bf648c0","171":"6f13d8b","172":"22f3827","173":"fd6d88d","174":"c9106a5","175":"d5cc4a5","176":"557e48e","177":"6d0d5bb","178":"ae89a20","179":"3b9b66a","180":"fe3cd1e","181":"9dcfb52","182":"23f3a59","183":"b07bf15","184":"cf8e69a","185":"854776e","186":"07a96ca","187":"bbf676e","188":"a5b96f2","189":"6209ece","190":"4d21c05","191":"870cf79","192":"0ff7999","193":"d521ae7","194":"868e29f","195":"1ea7017","196":"ab7bb74","197":"ff27f33","198":"d79a7e9","199":"a444d6a","200":"3b29102","201":"64e7269","202":"20a8bde","203":"019b18d","204":"ca4a9a6","205":"8138ef5","206":"4bbbf23","207":"45cc859","208":"82f2a04","209":"e29f946","210":"611f70a","211":"9643ca1","212":"75096d0","213":"becc7d8","214":"14a04fb","215":"4609d46","216":"1d415e6","217":"9808fed","218":"71f88ff","219":"3d8659c","220":"4a0fbc2","221":"a76be8a","222":"248bd3c","223":"d0f8605","224":"9a05b5a","225":"aed423a","226":"0ecc9b8","227":"f302b87","228":"2b61ccb","229":"6d1da8b","230":"b6725cc","231":"e2b7f16","232":"7361be8","233":"575c0e7","234":"d16204c","237":"b0b0ff0","238":"69a2646","239":"4129e79","240":"17168ad","241":"f96fe5c","242":"65b8314","243":"4974cc3","244":"cf3c0a1","245":"067dd94","246":"9627ac2","247":"61a289a","248":"94f54ba","249":"f209d63","250":"c1bf863","251":"70185aa","252":"768f7ca","253":"b36b68b","254":"716798d","255":"a018d52","256":"188a9d4","257":"34246d5","258":"a9ce24b","259":"f8e67b0","260":"57deb06","261":"0b6910f","262":"40756f6","263":"64760c2","264":"1aaa36e","265":"26364d1","266":"023a14b","267":"f3e7c89","268":"d1a4b0a","269":"6719dac","270":"d3c38ec","271":"3082014","272":"1dfd570","273":"59ad64f","274":"7d8acaf","275":"7a82237","276":"e469829","277":"e8ad369","278":"17ffcec","279":"f901493","280":"251ca16","281":"3239218","282":"34aece2","283":"16a0d93","284":"7e9b8d9","285":"3800a7c","286":"8e42a80","287":"8493d2d","288":"3d0c548","289":"ba4039f","290":"672747a","291":"ca02421","292":"80a358d","293":"7dcc454","294":"ddc9a2d","295":"5ccca4f","296":"a33694f","297":"1764153","298":"729ae21","299":"1291b11","300":"30dd707","301":"ec6154a","302":"114a6e9","303":"9b43096","304":"e5335df","305":"3b9d902","306":"76ef6d0","307":"7aeacf6","308":"26a4321","309":"a79a80f","310":"b79426b","311":"0e6a152","312":"dbb0b5b","313":"e7e251e","314":"f4cf41d","315":"a15f079","316":"7b138a3","317":"0c593ef","318":"1e019d1","319":"715f93c","320":"ca863ac","321":"b0516b3","322":"9e36439","323":"a71ed79","324":"9d333f0","325":"53eae42","326":"2707a47","327":"2983806","328":"e248e4e","329":"58a4b1e","330":"4edd333","331":"c936608","332":"4f4f3f7","333":"3ca71f0","334":"34a8b59","335":"2691017","336":"408f3ab","337":"d84ea0a","338":"ba8dd64","339":"255a123","340":"a47a174","341":"b6578fd","342":"c9db4ef","343":"9f795c1","344":"8c7b672","345":"275b8fb","346":"18e7ea6","347":"0a814a8","348":"bedbf0b","349":"b43eb86","350":"27d35d7","351":"6745b99","352":"e8d385e","353":"0521f4f","354":"df72a6f","355":"bf63b13","356":"a8fbfaf","357":"1b5ba09","358":"a3bb4fd","359":"1365eed","360":"7217f5f","361":"f664c28","362":"5d674c3","363":"440d1c5","364":"1c5ffd8","365":"28b4d7e","366":"b4f3cdc","367":"3954355","368":"a8455f1","369":"236d342","370":"028e7d6"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://d1mf56q6wc1y19.cloudfront.net/channels2022/220519/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
